export const TutorStatuses = {
  ACTIVE: "active",
  ARCHIVED: "archived",
  INACTIVE: "inactive"
};
